export class PAFormSearchModel {
    constructor() {
        this.columnFilters = [];
    }
}
export default class FormSearch extends PAFormSearchModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
